// Import section schemas
import { sharedQueries } from './shared';
import { adminQueries } from './admin';
import { hubQueries } from './hub';

// Export the complete query store
export const queryStore = {
  shared: sharedQueries,
  admin: adminQueries,
  hub: hubQueries,
}; 